const operaPermission = {
  '1': ['下载', '预览', '分享', '查看历史版本', '更多', '加入收藏'],
  '2': ['上传', '下载', '预览', '分享', '查看历史版本', '上传新版本', '更多', '加入收藏'],
  '3': ['上传', '下载', '预览', '分享', '删除', '重命名', '查看历史版本', '上传新版本', '移动到', '复制到', '新建文件夹', '更多', '加入收藏'],
  '4': ['上传', '下载', '预览', '分享', '删除', '重命名', '查看历史版本', '上传新版本', '移动到', '复制到', '新建文件夹', '设置', '更多', '加入收藏'],
  '5': ['上传', '下载', '预览', '分享', '删除', '重命名', '查看历史版本', '上传新版本', '移动到', '复制到', '新建文件夹', '更多', '加入收藏'],
  '6': ['下载', '分享']
}

const permissionJudge = function (permission, operation, map) {
  permission = String(permission)
  operation = String(operation)
  if (map[permission].indexOf(operation) !== -1) {
    return true
  }
  return false
}

const operaPermissionJudge = function (permission, operation) {
  return permissionJudge(permission, operation, operaPermission)
}

export default {
  operaPermissionJudge
}



// WEBPACK FOOTER //
// ./src/assets/js/permission.js